export const IMPORTLOG_GET_REPORT = 'IMPORTLOG_GET_REPORT';
export const IMPORTLOG_BEGIN_FETCH_REPORT = 'IMPORTLOG_BEGIN_FETCH_REPORT';
export const IMPORTLOG_END_FETCH_REPORT = 'IMPORTLOG_END_FETCH_REPORT';
// export const IMPORTLOG_FETCH_REPORT_SUCCESS = 'IMPORTLOG_FETCH_REPORT_SUCCESS';
// export const IMPORTLOG_FETCH_REPORT_FAIL = 'IMPORTLOG_FETCH_REPORT_FAIL';
export const IMPORTLOG_CLEAR = 'IMPORTLOG_CLEAR';
export const IMPORTLOG_ERROR = 'IMPORTLOG_ERROR';



// WEBPACK FOOTER //
// ./src/pages/importlog/state/types.js